import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeaf = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M10.25 19.09C8.25289 19.09 6.33761 18.2967 4.92546 16.8845C3.51331 15.4724 2.71997 13.5571 2.71997 11.56C2.71997 0.640006 15.86 6.25001 22.19 1.00001C22.2622 0.955817 22.3453 0.932434 22.43 0.932434C22.5147 0.932434 22.5977 0.955817 22.67 1.00001C22.7475 1.03353 22.8156 1.08581 22.8679 1.15214C22.9203 1.21847 22.9554 1.29677 22.97 1.38001C24.9 12.64 16.57 19.09 10.25 19.09Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.26 9.55C10.1393 10.4091 7.21523 11.8661 4.65 13.84L0.75 17.17",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgLeaf;
